<template>
<div class="box_finder" :class="{ 'is-loading': loading }">
    <div class="hls"><span>{{ $translate("AdvancedFinder::Template.AdvancedFinder01") }}</span>
        <svg width="67" height="40" viewBox="0 0 67 40">
            <use href="#svg_truck"></use>
        </svg>
    </div>

    <form>
        <select v-model="firstCategoryId" @change="fetchSecondCategories($event.target.value); resetFields(true)" name="manufacturer" id="manufacturer">
            <optgroup :label="$translate('AdvancedFinder::Template.AdvancedFinder02')">
                <option selected hidden disabled value="-1" default>{{ $translate("AdvancedFinder::Template.AdvancedFinder02") }}</option>
                <option v-for="(category, index) in firstCategories" :key="index" :value="category.id">
                    {{ category.name }}
                </option>
            </optgroup>
        </select>

        <select v-model="secondCategoryId" @change="fetchFacets($event.target.value); resetFields()" :disabled="firstCategoryId == -1" name="model" id="model">
            <optgroup :label="$translate('AdvancedFinder::Template.AdvancedFinder03')">
                <option selected hidden disabled value="-1" default>{{ $translate("AdvancedFinder::Template.AdvancedFinder03") }}</option>
                <option v-for="(category, index) in secondCategories" :key="index" :value="category.id">
                    {{ category.name }}
                </option>
            </optgroup>
        </select>

        <select v-model="facetId" @change="getUrl($event.target.value)" :disabled="secondCategoryId == -1 || secondCategoryId && facets.length == 0" name="position" id="position">
            <optgroup :label="$translate('AdvancedFinder::Template.AdvancedFinder04')">
                <option selected hidden disabled value="-1" default>{{ $translate("AdvancedFinder::Template.AdvancedFinder04") }}</option>
                <option v-for="(facet, index) in facets" :key="index" :value="facet.plenty_facet_value_id">
                    {{ facet.plenty_facet_value_lang_name }}
                </option>
            </optgroup>
        </select>

        <a :href="url" aria-hidden="true">
            <svg width="15" height="15" viewBox="0 0 15 15">
                <use href="#svg_magSM"></use>
            </svg>
            <span v-text="total === 0 ? $translate('AdvancedFinder::Template.AdvancedFinder05') : total + ' ' + $translate('AdvancedFinder::Template.AdvancedFinder06')"></span>
        </a>
    </form>
</div>
</template>

<script>
export default {
    data() {
        return {
            firstCategoryId: -1,
            firstCategories: [],
            secondCategoryId: -1,
            secondCategories: [],
            facetId: -1,
            facets: [],
            url: '#',
            loading: false,
            total: 0
        }
    },

    // props: {
    //     buttonText: {
    //         type: String,
    //         default: 'Search',
    //     },
    //     selectFirstCategoryText: {
    //         type: String,
    //         default: 'Select first category',
    //     },
    //     selectSecondCategoryText: {
    //         type: String,
    //         default: 'Select second category',
    //     },
    //     selectFacetText: {
    //         type: String,
    //         default: 'Select facet',
    //     }
    // },

    mounted() {
        this.fetchFirstCategories()
    },

    // computed: {
    //     computedButtonText() {
    //         return this.total ? `${this.total} Artikel anzeigen` : this.buttonText
    //     }
    // },

    methods: {
        resetFields(all = false) {
            if (all) {
                this.secondCategoryId = -1
                this.facetId = -1
                this.facets = []

                return
            }

            this.facetId = -1
        },

        getUrlById(id, categories) {
            const category = categories.find((category) => category.id === parseInt(id));
            return category ? category.url : null;
        },

        fetchFirstCategories() {
            this.loading = true;

            fetch('/rest/cyt/finder/categories')
                .then((response) => response.json())
                .then((data) => {
                    this.firstCategories = data;
                    this.loading = false;
                });
        },

        fetchSecondCategories(categoryId) {
            this.loading = true;

            const url = `/rest/cyt/finder/categories/?categoryId=${categoryId}`;

            fetch(url)
                .then((response) => response.json())
                .then((data) => {
                    this.secondCategories = data;
                    this.getTotal(categoryId);
                    this.url = this.getUrlById(categoryId, this.firstCategories)
                });
        },

        fetchFacets(categoryId) {
            this.loading = true;

            const url = `/rest/cyt/finder/facets/?categoryId=${categoryId}`;

            fetch(url)
                .then((response) => response.json())
                .then((data) => {
                    this.facets = data;
                    this.getTotal(categoryId);
                    this.url = this.getUrlById(categoryId, this.secondCategories);
                });
        },

        getTotal: function(categoryId, facetId) {
            this.loading = true;

            let urlParams = `?categoryId=${categoryId}`;

            if (facetId) {
                urlParams += `&facetId=${facetId}`;
            }

            const url = `/rest/cyt/finder/total/${urlParams}`;

            fetch(url)
                .then((response) => response.json())
                .then((data) => {
                    this.total = data.total;

                    setTimeout(() => {
                        this.loading = false;
                    }, 150);
                });
        },

        getUrl(facetId) {
            this.getTotal(this.secondCategoryId, facetId)
            this.url = this.url.replace(/([?]+facets=\d.)/g, '') + '?facets=' + facetId
        }
    }
}
</script>
